import { render, staticRenderFns } from "./searchGrade.vue?vue&type=template&id=585dbd1c&scoped=true"
import script from "./searchGrade.vue?vue&type=script&lang=js"
export * from "./searchGrade.vue?vue&type=script&lang=js"
import style0 from "./searchGrade.vue?vue&type=style&index=0&id=585dbd1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585dbd1c",
  null
  
)

export default component.exports